import React, { useEffect, useState } from "react";
import {
  FaBookmark,
  FaEdit,
  FaEnvelope,
  FaReply,
  FaSignInAlt,
  FaSignOutAlt,
  FaSignature,
  FaUpload,
  FaUserCheck,
  FaUserTimes,
} from "react-icons/fa";
import {
  FaCircleCheck,
  FaCirclePlus,
  FaCircleXmark,
  FaTrashCan,
} from "react-icons/fa6";
import Moment from "react-moment";
import { useParams } from "react-router";
import { Table } from "react-bootstrap";
import Pagination from "../../../../../ETMF/Pagination/Pagination";
import {
  NoDataFoundTable,
  SpinerDataLoader,
} from "../../../../../NoDataFoundTable/NoDataFoundTable";
import { usersOnboardingService } from "../../../../../../Services/usersOnboarding";
import SplitPane from "react-split-pane";

const StudyEventAuditLogs = ({ onMouseDown1, tableRef1, visitUniqueId }) => {
  const { studyId } = useParams();
  const [recentActivity, setRecentActivity] = useState([]);
  const [tableLoader, setTableLoader] = useState(false);
  let studyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getStudyActivitiesByModule = async () => {
    setTableLoader(true);
    let data = await usersOnboardingService.getStudyActivitiesByModule(
      visitUniqueId,
      studyId,
      "studyEvent",
      studyMode
    );
    setRecentActivity(data?.data || []);
    setTableLoader(false);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const result = recentActivity?.slice(startIndex, endIndex);
  const totalPage = Math.ceil(recentActivity?.length / itemsPerPage);

  useEffect(() => {
    getStudyActivitiesByModule();
  }, [visitUniqueId]);
  return (
    <>
      <SplitPane split="vertical" minSize={20} defaultSize={"100%"}>
        {tableLoader ? (
          <SpinerDataLoader />
        ) : recentActivity?.length === 0 ? (
          <NoDataFoundTable MSG="Activity not found" />
        ) : (
          <>
            <Table
              id="resizable-table"
              striped
              className="custom-table"
              style={{ tableLayout: "auto" }}
              hover
              bordered
              ref={tableRef1}
            >
              <thead className="thead-sticky" style={{ top: -1 }}>
                <tr>
                  <th
                    onMouseDown1={(e) => onMouseDown1(e, 0)}
                    style={{ width: 40 }}
                  >
                    Sr.
                  </th>
                  <th
                    className="text-center"
                    onMouseDown1={(e) => onMouseDown1(e, 1)}
                  >
                    Status
                  </th>
                  <th
                    className="text-center"
                    onMouseDown1={(e) => onMouseDown1(e, 2)}
                  >
                    Type
                  </th>
                  <th onMouseDown1={(e) => onMouseDown1(e, 3)}>Activities</th>
                  <th onMouseDown1={(e) => onMouseDown1(e, 4)}>Activity By</th>
                  <th onMouseDown1={(e) => onMouseDown1(e, 5)}>Activity Date</th>
                  <th onMouseDown1={(e) => onMouseDown1(e, 6)}>Activity Time</th>
                </tr>
              </thead>
              <tbody>
                {result?.map((item, index) => (
                  <tr className="relative">
                    <td>{index + startIndex + 1}.</td>
                    <td
                      title={item.status === "200" ? "Success" : "Failed"}
                      className="text-center"
                    >
                      {item.status === "200" ? (
                        <FaCircleCheck className="text-success" />
                      ) : (
                        <FaCircleXmark className="text-danger" />
                      )}
                    </td>
                    <td className="text-center text-capitalize">
                      {item.type}
                    </td>
                    <td>{item.activities}</td>
                    <td title={item.activityBy}>{item.activityByName}</td>
                    <td>
                      <Moment format="DD MMM YYYY">{item?.createdAt}</Moment>
                    </td>
                    <td>
                      <Moment format="HH:mm:ss">{item?.createdAt}</Moment>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky" style={{ bottom: 24 }}>
              <Pagination
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                totalPage={totalPage}
                totalItems={recentActivity?.length}
              />
            </div>
          </>
        )}
      </SplitPane>
    </>
  );
};

export default StudyEventAuditLogs;
